import React, { useState, useEffect } from 'react'
import Main from '../Main'
import BackToService from './BackToService';
import Color from 'color-converter'
import randomColor from 'randomcolor'
import hexColorInfo from 'hex-colors-info'
import hexToHsl from 'hex-to-hsl'
import copy from 'copy-to-clipboard';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import notFound from '../assets/img/undraw_not_found_60pq.png'


function ColorConversion() {
    let selectedColor = randomColor();
    /* console.log(randomColor({
         count: 10,
         hue: '#c911dd'
      }))*/
    const [color, setColor] = useState(selectedColor);
    const [colorDetails, setColorDetails] = useState({});
    const [isResultGet, setIsResultGet] = useState(true);

    var copyToClipBoard = () => {
        copy(`Name : ${colorDetails.colorName}, Hex : ${colorDetails.css}, RGB : ${colorDetails.rgb}, HSL : ${colorDetails.hsl}`);
        toast('Copied', {
            type: "success",
        });
    }

    const fetchDetails = () => {
        try {
            let colorData = {};
            let colorFun = Color.fromCSS(color);
            let rgb = colorFun.toRGB();
            let hsl = colorFun.toHSL();
            let hsv = colorFun.toHSV();
            let colorName = colorFun.toName();
            let hexName = colorFun.css();
            let hexDetails = hexColorInfo(hexName);
            let hslDetails = hexToHsl(hexName);
            let hslData = hslDetails.length ? `hsl (${hslDetails[0]}, ${hslDetails[1]}%, ${hslDetails[2]}%)` : "";
            colorData = {
                colorName: colorName ? colorName : hexDetails.name,
                css: hexName,
                rgb: `rgb (${rgb.r}, ${rgb.g}, ${rgb.b})`,
                hsl: hslData ? hslData : `hsl (${hsl.h}, ${hsl.s}, ${hsl.l})`
            }
            setColorDetails(colorData);
            setIsResultGet(true);
        } catch (e) {
            setIsResultGet(false);
        }
    };

    useEffect(() => {
        fetchDetails();
    }, [])

    if (!isResultGet) {
        return (
            <>
                <Main active="service">
                    <ToastContainer autoClose={2000} />
                    <div className="main">
                        <section>
                            <div className="container section-title">
                                <h2>Color Convertor <BackToService /></h2>
                                <div className="row">
                                    <div className="col-md-12">
                                        <em>Search CSS color value (like "#aaa", "rgba(0,0,0,.5)" or "red")</em>
                                    </div>
                                    <div className="col-md-12 color-convertor-div">
                                        <div className="card" style={{ "border": "none" }}>
                                            <div className="card-body">
                                                <div className="input-group mb-3" style={{ "width": "40%" }}>
                                                    <input type="text" className="form-control" value={color} onChange={(e) => setColor(e.target.value)} placeholder="Search Github User" ariaLabel="Recipient's username" ariaDescribedby="basic-addon2" />
                                                    <div className="input-group-append">
                                                        <button className="btn btn-primary" type="button" disabled={color ? false : true} onClick={fetchDetails}>Convert</button>
                                                    </div>
                                                </div>
                                                <img src={notFound} alt="" style={{ "height": "calc(100vh - 330px)" }} className="img-thumbnail" />
                                                <h4 style={{ "color": "#173b6c", "textAlign": "center" }}>Oops! Something went wrong</h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </Main>
            </>
        )
    } else {
        return (
            <>
                <Main active="service">
                    <div className="main">
                        <section>
                            <div className="container section-title">
                                <h2>Color Convertor <BackToService /></h2>
                                <div className="row" style={{ "marginTop": "50px" }}>
                                    <div className="col-md-12">
                                        <em>Search CSS color value (like "#aaa", "rgba(0,0,0,.5)" or "red")</em>
                                    </div>
                                    <div className="col-md-12 color-convertor-div">
                                        <div className="card" style={{ "border": "none" }}>
                                            <div className="card-body">
                                                <div className="input-group mb-3" style={{ "width": "40%" }}>
                                                    <input type="text" className="form-control" value={color} onChange={(e) => setColor(e.target.value)} placeholder="Search Github User" ariaLabel="Recipient's username" ariaDescribedby="basic-addon2" />
                                                    <div className="input-group-append">
                                                        <button className="btn btn-primary" type="button" onClick={fetchDetails}>Convert</button>
                                                    </div>
                                                </div>
                                                <div className="row" style={{ "marginTop": "50px" }}>
                                                    <div className="col-md-3">
                                                        <div className="color-body" title="Click to copy" onClick={copyToClipBoard} style={{ "height": "220px", "backgroundColor": colorDetails ? colorDetails.css : "" }}></div>
                                                        <h5 style={{ "color": "#173b6c", "textAlign": "center" }}>Click to copy</h5>
                                                    </div>
                                                    <div className="col-md-7 row" style={{ "marginLeft": "40px", "maxHeight": "calc(100vh - 330px)", "overflowY": "auto" }}>
                                                        <div className="col-md-3"><strong>Name  </strong></div><div className="col-md-9">{colorDetails ? colorDetails.colorName : ""}</div>
                                                        <div className="col-md-3"><strong sty>Hax</strong></div><div className="col-md-9">{colorDetails ? colorDetails.css : ""}</div>
                                                        <div className="col-md-3"><strong>RGB  </strong></div><div className="col-md-9">{colorDetails ? colorDetails.rgb : ""}</div>
                                                        <div className="col-md-3"><strong>HSL  </strong></div><div className="col-md-9">{colorDetails ? colorDetails.hsl : ""}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </section>
                    </div>
                </Main>
            </>
        )
    }
}

export default ColorConversion
